const MoldovaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111904)">
      <path
        d="M28.6953 1.98453C26.066 0.713125 23.1161 0 19.9997 0C16.8833 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155C13.9335 39.2869 16.8833 40 19.9997 40C23.1161 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453Z"
        fill="#FFDA44"
      />
      <path
        d="M11.3044 1.98535C4.61453 5.22027 0 12.071 0 20.0001C0 27.9293 4.61453 34.78 11.3044 38.0149V1.98535Z"
        fill="#0052B4"
      />
      <path
        d="M28.6958 1.98535V38.0149C35.3856 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3856 5.22027 28.6958 1.98535Z"
        fill="#D80027"
      />
      <path
        d="M26.9564 15.7354H22.1738C22.1738 14.5348 21.2006 13.5615 19.9999 13.5615C18.7993 13.5615 17.826 14.5348 17.826 15.7354H13.0435C13.0435 16.9175 14.0732 17.8757 15.2552 17.8757H15.1839C15.1839 19.0579 16.1422 20.0163 17.3244 20.0163C17.3244 21.0629 18.0761 21.9326 19.0689 22.1186L17.3822 25.9265C18.1904 26.255 19.0737 26.4376 19.9999 26.4376C20.9261 26.4376 21.8095 26.255 22.6176 25.9265L20.931 22.1186C21.9238 21.9326 22.6755 21.0629 22.6755 20.0163C23.8577 20.0163 24.816 19.0579 24.816 17.8757H24.7446C25.9267 17.8757 26.9564 16.9175 26.9564 15.7354Z"
        fill="#FF9811"
      />
      <path
        d="M20.0004 18.6953L17.1743 19.9997V22.6084L20.0004 24.3475L22.8265 22.6084V19.9997L20.0004 18.6953Z"
        fill="#0052B4"
      />
      <path d="M17.1743 17.3916H22.8265V20.0003H17.1743V17.3916Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111904">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MoldovaSvg;
